<template>
  <div class="financingInfo">

    <table border="0" cellpadding="0" cellspacing="0" class="tableCol2" style="width: 1020px;">
      <!--      <tr>-->
      <!--        <td class="td1">-->
      <!--&lt;!&ndash;          预计开始日期&ndash;&gt;-->
      <!--          {{$t('loan.expectStartDate')}}：</td>-->
      <!--        <td class="td2">{{data.estimateStartDate | dateConvert}}</td>-->
      <!--      </tr>-->
      <!--      <tr>-->
      <!--        <td class="td1">-->
      <!--&lt;!&ndash;          预计到期日期&ndash;&gt;-->
      <!--          {{$t('loan.expectDueDate')}}：</td>-->
      <!--        <td class="td2">{{data.estimateEndDate | dateConvert}}</td>-->
      <!--      </tr>-->
      <!--      <tr>-->
      <!--        <td class="td1">-->
      <!--&lt;!&ndash;          天数&ndash;&gt;-->
      <!--          {{$t('loan.numberOfDay')}}：</td>-->
      <!--        <td class="td2">{{data.days}} {{$t('frontPage.day')}}</td>-->
      <!--      </tr>-->
      <tr>
        <td class="td1">
          <!--          融资金额-->
          {{ $t('loan.financingmount') }}：</td>
        <td class="td2">{{ data.financingCurrency }} {{ data.financingMoney | formatNum }}</td>
      </tr>
      <tr>
        <td class="td1">
          <!--          利率-->
          {{ $t('loan.interestRate') }}：</td>
        <td class="td2">{{ data.interestRate }}%</td>
      </tr>
      <tr>
        <td class="td1">
          <!--          利息-->
          {{ $t('loan.interest') }}：</td>
        <td class="td2">{{ data.interestCurrency }} {{ data.interest | formatNum }}</td>
      </tr>
      <tr>
        <td class="td1">
          <!--          总费用-->
          {{ $t('loan.totalCost') }}：</td>
        <td class="td2">US$ {{ data.totalCost | formatNum }}</td>
      </tr>
      <tr>
        <td class="td1">
          <!--          发放币种-->
          {{ $t('loan.issueCurrency') }}：</td>
        <td class="td2">{{ data.grantCurrency }}</td>
      </tr>
      <tr>
        <td class="td1">
          <!--          还款币种-->
          {{ $t('loan.paymentCurrency') }}：</td>
        <td class="td2">{{ data.repaymentCurrency }}</td>
      </tr>
      <tr>
        <td class="td1">
          <!--          汇率-->
          {{ $t('loan.exchangeRate') }}：</td>
        <td class="td2">{{ data.exchangeRate }}</td>
      </tr>
    </table>

    <!--    <div style="color: red;">-->
    <!--      资金出入日期 预留-->

    <!--    </div>-->

    <!--                  资金出入日期-->
    <time-of-capital ref="timeCapital" class="pb-10" @confirmClick="confirmUpdate"/>

    <!--    <fund-lock :fundData="fundData"></fund-lock>-->

    <!--    <table border="0" cellpadding="0" cellspacing="0" class="tableCol2"  style="width: 1020px;">-->
    <!--      <tr v-if="data.lockedMoney || data.lockedMoney==0">-->
    <!--        <td class="td1" colspan="2">-->
    <!--          <div class="nyTit" style="margin-bottom: 10px;"><i></i>-->
    <!--&lt;!&ndash;            资金锁定&ndash;&gt;-->
    <!--            {{$t('financingFundDetail.Tit9')}}-->
    <!--          </div>-->
    <!--        </td>-->
    <!--&lt;!&ndash;        <td class="td2"></td>&ndash;&gt;-->
    <!--      </tr>-->
    <!--      <tr v-if="data.lockedMoney || data.lockedMoney==0">-->
    <!--        <td class="td1">-->
    <!--&lt;!&ndash;          资金锁定额&ndash;&gt;-->
    <!--          {{$t('financingFundDetail.lockMoneyTip')}}-->
    <!--        </td>-->
    <!--        <td class="td2">{{data.lockedCurrency}} {{data.lockedMoney | formatNum}} </td>-->
    <!--      </tr>-->
    <!--&lt;!&ndash;      <tr>&ndash;&gt;-->
    <!--&lt;!&ndash;        <td class="td1"></td>&ndash;&gt;-->
    <!--&lt;!&ndash;        <td class="td2"></td>&ndash;&gt;-->
    <!--&lt;!&ndash;      </tr>&ndash;&gt;-->
    <!--    </table>-->
    <!--    资金锁定-->
  </div>
</template>
<script>
import timeOfCapital from '@/components/timeOfCapitalFlow/index'
export default {
  name: 'FinancingInfo',
  components: {
    // fundLock,
    timeOfCapital
  },
  props: ['data', 'status'],
  data() {
    return {
      moneyType: '',
      timeList: ''
    }
  },
  mounted() {
    this.$nextTick(function() {
      // console.log(this.data);
      // console.log('applicationStatus:'+ this.status);
      this.getdiscList()
    })
  },
  methods: {
    initData(obj) {
      this.timeList = obj
      this.$nextTick(() => {
        const timeCapitalData = {
          zmaUpdateTimeLogs: this.timeList ? this.timeList : [] // 时间列表
        }
        this.$refs.timeCapital.initData(timeCapitalData)
      })
    }, // 初始化数据

    /**
       *  调整锁定金额成功 回调
       */
    confirmUpdate() {
      this.$emit('update')
    },

    // 取字典表的value
    getdiscList() {
      this.axios.get('/static/sysDict/sysDictValue.json')
        .then(res => {
          // console.log('字典表',res);//capitalList
          if (res.moneyType && res.moneyType.en) {
            this.moneyType = res.moneyType.en
          }
        })
        .catch(err => {
          this.$message.error(this.$t(`frontPage.${err.errorCode}`))
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .theme-default.el-input{
    width: 520px;
  }
</style>

